import {capitalizeName, hasAllowedCharacters, limitStringLength, moveFirstWordToEnd} from './helpers';

export function formatBookTitle(
  titleFromThorpe?: string | null,
  titleFromEbility?: string | null,
): string | null {

  if (titleFromThorpe && hasAllowedCharacters(titleFromThorpe)) {
    return capitalizeName(titleFromThorpe);
  }

  if (titleFromEbility) {
    return capitalizeName(titleFromEbility);
  }

  return null;
}

export function formatAuthorName(
  authorFromThorpe?: string | null,
  authorFromEbility?: string | null,
): string | null {
  if (authorFromThorpe) {
    let author = authorFromThorpe;

    // If a book has multiple authors, they are separated by a a semicolon.
    author = author
      .replaceAll('; ', ' & ')
      .replaceAll(', ', '& ')
      .replaceAll(',', '&')
      .split('&')
      .join(' & ');
    author = moveBetweenParenthesesToEnd(author);

    author =
      author.startsWith('&') || author.startsWith(' &')
        ? author.slice(2)
        : author;

    return limitStringLength(capitalizeName(author, true).trim(), 140);
  }

  if (!authorFromEbility) return null;

  let author = authorFromEbility.toLowerCase();
  // In eBility we put the surname first and then any first names after that so the TUNG example is Robyn Maree Pickens. Even with those with double barrelled (but unhyphenated) surnames it should work: ebility will show MARQUEZ GABRIEL GARCIA and the website should show Gabriel Garcia Marquez.
  author = author
    .replaceAll(';', '&')
    .replaceAll(', ', '& ')
    .replaceAll(',', '&');
  author = author.split('&').reverse().join(' & ');

  // The “&” separates the authors but all names are reversed – should read Sean Barnett & Rob Brown & Geoff Spearpoint. There is some inconsistency as sometimes authors are separated by a comma or a semicolon. So in the Author field use these as with the &.
  const authors = author.split('&');
  author = authors.map(moveFirstWordToEnd).join(' & ');

  // Move editors and translators to the end of the author list.
  author = moveBetweenParenthesesToEnd(author);

  // (ED) is editor. I think we need to note this in the author display: Could we have “(editor)” spelled out and all lower case showing after each name when “(ED)” ? EG from below:
  author = author.replaceAll('(ed)', '(editor)');
  author = author.replaceAll('(trans)', '(translator)');

  // Carrie Ridzinski & Grace Iwashita-Taylor (editor)
  return limitStringLength(capitalizeName(author, true).trim(), 140);
}

function moveBetweenParenthesesToEnd(str: string) {
  const parts = str.split(' & ');
  const withParentheses: string[] = [];
  const withoutParentheses: string[] = [];

  parts.forEach((part) => {
    if (part.includes('(') && part.includes(')')) {
      withParentheses.push(part);
    } else {
      withoutParentheses.push(part);
    }
  });

  return [...withoutParentheses, ...withParentheses].join(' & ');
}
